module.exports = __webpack_public_path__ + "static/media/ComoComprarv2.2bba0a36.mp4";